var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('json-viewer',{staticClass:"entity-viewer-root",attrs:{"source":_vm.displaySource}})}
var staticRenderFns = []

export { render, staticRenderFns }